import * as React from "react";
import { QueryRoute } from "bernie-core";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkCard, UitkCardContent, UitkCardLink, UitkPlaceholderCard } from "uitk-react-cards";
import { MapProps } from "./typings";
import { Action, FlexTrackingInfo, sendDelayedTrackEvent } from "components/utility/analytics/FlexAnalyticsUtils";
import FullScreenMap from "./FullScreenMap";
import { withStores } from "src/stores";
import LazyLoad from "react-lazyload";

const Map = withStores(
  "analytics",
  "routeStore"
)((props: MapProps) => {
  const { analytics, routeStore, staticMap, destination, pois, hotels, activities, context } = props;
  const { formatText } = useLocalization();
  /* covered in e2e test */
  /* istanbul ignore next line */
  const toggleMapDialog = (toggleAction: string) => (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ): void => {
    e.preventDefault();
    const sidebarContainer = document.getElementsByClassName("dx-sidebar-content")[0];
    if (toggleAction === "open") {
      const flexTrackingInfo: FlexTrackingInfo = {
        moduleName: "TG.LP.Dest.Map.open",
        action: Action.CLICK
      };
      sendDelayedTrackEvent(flexTrackingInfo, analytics);
      if (sidebarContainer) {
        sidebarContainer.classList.add("z-index-250");
      }
      routeStore.updateSearch({ map: "open" });
    } else {
      // Event tracking is left out of the close toggle as it is handled in FullScreenMap.tsx.
      // This is to account for all the methods for exiting the map rather that just the toggle.
      if (sidebarContainer) {
        sidebarContainer.classList.remove("z-index-250");
      }
      routeStore.updateSearch({ map: undefined });
    }
  };

  const staticMapBg = { backgroundImage: `url(${staticMap})` };

  return (
    <>
      <LazyLoad
        placeholder={
          <a href="#" onClick={toggleMapDialog("open")} data-testid="map-target">
            <UitkPlaceholderCard />
          </a>
        }
      >
        <UitkCard>
          <UitkCardContent>
            <div className="uitk-cell image-map" style={staticMapBg} />
            <UitkCardLink>
              <a href="#" onClick={toggleMapDialog("open")} data-testid="map-target">
                {formatText("destinationDiscoveryMap.button.open")}
              </a>
            </UitkCardLink>
          </UitkCardContent>
        </UitkCard>
      </LazyLoad>
      <QueryRoute query={{ map: "open" }}>
        <FullScreenMap
          context={context}
          destination={destination}
          pois={pois}
          hotels={hotels}
          activities={activities}
          showMap={routeStore.queryParams.map === "open"}
          toggleMapDialog={toggleMapDialog}
        />
      </QueryRoute>
    </>
  );
});

export default Map;
